module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.LoggedIn === true) ? _c('div', {
    staticClass: "toolbar bottomToolbarContainer",
    style: (_vm.cssVars)
  }, [_c('bottom-items', {
    attrs: {
      "serviceId": _vm.serviceId,
      "bottomItemsData": _vm.bottomItemsData
    }
  })], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3a8b116a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a8b116a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomToolbar/bottomToolbar.vue
// module id = 2334
// module chunks = 2